
import { FC } from 'react';
// 创建/编辑表单抽屉
import ChanceCreateDrawer from '../ChanceCreateDrawer';
// 详情抽屉
import ChanceDetailDrawer from '../ChanceDetailDrawer';

/** 机会点创建/编辑、详情-抽屉组件 */
const ChancePointDetail: FC<{
  // 点位详情所用字段
  /** 机会点id/点位id */
  pointId,
  detailVisible,
  /** 创建机会点时默认赋值的字段 */
  assignedData?,
  /** 创建机会点后需要关联任务 */
  needAssiocateChance?,
  /** 创建时用于查询商圈默认资源库项目的拓店任务 ID */
  taskId?: number,
  /** 商圈城市、名称，仅用于项目列表默认筛选。 */
  projectSearchDefaults?: { city?: (number | null | undefined)[]; projectName?: string | null; longitude?: number | string | null; latitude?: number | string | null },
  chancepointAlias?,
  setDetailVisible,
  /** 设置编辑表单状态 */
  setFormDrawerData,
  /** 触发列表搜索逻辑 */
  onSearch,
  /** 刷新列表当前页（类似onSearch，满足差异化需求） */
  onSearchCurrentPage?,
  /** 触发详情更新的逻辑 */
  refreshDetail?,
  /** 表单抽屉所需数据 */
  formDrawerData,
  /** 拓店任务id，以后可能会用到 */
  // expansionTaskId?,
  /** 拓店任务商圈id */
  expansionTaskClusterId?,
  /** 是否 Locxx 拓店任务机会点。 */
  isLocxxTask?: boolean,
  /** Locxx 新建保存后关联到当前任务。 */
  handleLocxxSave?: (chancePointId: number) => Promise<void> | void,
  /** 创建机会点成功的回调 */
  handleCreateSuccessed?,
  /** 更新详情的处理 */
  updateHandle?,
}> = ({
  // 点位详情所用字段
  pointId, // 机会点id/点位id
  detailVisible,
  assignedData, // 创建机会点时默认赋值的字段
  needAssiocateChance, // 创建机会点后需要关联任务
  taskId,
  projectSearchDefaults,
  chancepointAlias,
  setDetailVisible,
  setFormDrawerData, // 设置编辑表单状态
  onSearch, // 触发列表搜索逻辑
  onSearchCurrentPage, // 刷新列表当前页（类似onSearch，满足差异化需求）
  refreshDetail, // 触发详情更新的逻辑
  formDrawerData, // 表单抽屉所需数据
  // expansionTaskId,
  expansionTaskClusterId,
  isLocxxTask,
  handleLocxxSave,
  handleCreateSuccessed,
  updateHandle, // 更新详情的处理
}) => {

  return (
    <>

      {/* 机会点详情组件 */}
      <ChanceDetailDrawer
        id={pointId}
        open={detailVisible}
        setOpen={setDetailVisible}
        setFormDrawerData={setFormDrawerData}
        onSearch={onSearch}
        onSearchCurrentPage={onSearchCurrentPage}
        updateHandle={updateHandle}
        refreshDetail={refreshDetail}
      />

      {/* 创建/编辑机会点 */}
      <ChanceCreateDrawer
        drawerData={formDrawerData}
        onSearch={onSearch}
        assignedData={assignedData}
        needAssiocateChance={needAssiocateChance}
        taskId={taskId}
        projectSearchDefaults={projectSearchDefaults}
        chancepointAlias={chancepointAlias}
        // expansionTaskId={expansionTaskId}
        expansionTaskClusterId={expansionTaskClusterId}
        isLocxxTask={isLocxxTask}
        handleLocxxSave={handleLocxxSave}
        handleCreateSuccessed={handleCreateSuccessed}
        handleEditSuccessed={updateHandle}
        closeHandle={() =>
          setFormDrawerData({
            open: false,
            templateId: '', // 模板id
            id: '', // 编辑时的id
          })
        }
      />
    </>
  );
};

export default ChancePointDetail;
